import React from "react";
import Accordion from "react-bootstrap/Accordion";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../common/Header';

const FaqComponent = () => {
  const faqs = [
    {
      question: "What is this application about?",
      answer: "This application helps users manage their tasks efficiently using modern tools."
    },
    {
      question: "How can I reset my password?",
      answer: "You can reset your password by clicking on 'Forgot Password' on the login screen."
    },
    {
      question: "Is my data secure?",
      answer: "Yes, we use industry-standard encryption and authentication protocols to secure your data."
    },
    {
      question: "How do I contact support?",
      answer: "You can contact support through the contact form in the 'Help' section."
    },
    {
      question: "Can I use this on mobile?",
      answer: "Absolutely! The app is fully responsive and works great on all devices."
    }
  ];

  return (
    <div className="container-fluid d-flex flex-column w-100 p-0 m-0">
      <Header />
      <div className="container my-5">
        <h2 className="mb-4 text-center">Frequently Asked Questions</h2>
        <Accordion defaultActiveKey="0">
          {faqs.map((faq, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header>{faq.question}</Accordion.Header>
              <Accordion.Body>{faq.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FaqComponent;
